export interface AuthHandlerResult {
  state: boolean
  callback?: (() => void) | null
}

export type AuthHandler = (
  event: Event,
  target: HTMLElement,
  userid?: string,
  callback?: (() => void) | null
) => AuthHandlerResult

export interface MemberAuthHandlers {
  [key: string]: AuthHandler
}

export interface IMemberAuthManager {
  register: (authCode: string, handler: AuthHandler) => void
  unregister: (authCode: string) => void
}

const memberAuthHandlers: MemberAuthHandlers = {
  '0001'(event: Event, target: HTMLElement): AuthHandlerResult {
    console.log('执行权限 0001 函数', event, target)
    const result = confirm('1.1-验证会员权益快照，是否执行下一步')
    return { state: result }
  },
  
  '0003'(_event: Event, _target: HTMLElement): AuthHandlerResult {
    console.log('执行权限 0003 函数')
    return { state: false }
  }
}

function default_auth(event: Event, target: HTMLElement, userid?: string, callback?: (() => void) | null): AuthHandlerResult {
  //有authcode的dom组件一定是要登录的会员才能用的，所以第一步验证是否登录
  // 如果未登录
     //拼装弹出要求扫码登录对话框的数据结构，{"state":false,"callback":showLoginModal} 
  //如果登录了
    //根据该用户的userid 到后台验证该用户的权益快照里有没有 0002这个权益
      // 如果有
        //拼装放行数据结构，{"state":true,"callback":null}
      // 如果没有
          //判断开发是否传入了自定义回调
            //如果有自定义回调
               //拼装阻断数据结构+自定义回调  return {"state":false,"callback":callback};
            //如果没有自定义回调
               //拼装阻断数据结构+默认会员无法享受此服务的提示  return {"state":false,"callback":showWarnModal};

  // 这种权益码目前来看，处理函数是通用的
  // 1、后台绑定权益码与功能： 权益码本身只是个流水号，并没有任何意义，需要在后台ui上让权益码和某一个功能进行绑定，这个权益码才有应用层上的意义
  //功能（动作）+权益码=功能（动作）权益
  // 2、后台绑定商品与功能权益：后台建立会员类型商品时，要把各种功能权益 与会员商品绑定
  // 3，memberAuthHandlers 需要支持传入自定义回调

  console.log('default_auth event', event)
  console.log('default_auth target', target)
  console.log('default_auth userid', userid)
  
  const result: AuthHandlerResult = { state: false, callback: null }
  
  if (callback && typeof callback === 'function') {
    result.callback = callback
  }else{
    result.callback=()=>{
      window.alert('我是验证失败的默认回调')
    }
  }
  
  return result
}

document.addEventListener('click', function(event: Event) {
  const target = (event.target as HTMLElement).closest('[member-auth]')
  if (!target) return

  const authCode = target.getAttribute('member-auth')
  const callbackStr = target.getAttribute('auth-callback')
  let callback: (() => void) | null = null
  
  if (callbackStr) {
    try {
      // 尝试1: 作为点分隔路径解析 (如 window.alert, myApp.callback)
      const parts = callbackStr.split('.')
      callback = parts.reduce((obj: any, key: string) => obj && obj[key], window)
      
      // 尝试2: 如果解析失败，检查是否是函数调用表达式 (如 alert('123'))
       if (typeof callback !== 'function') {
         if (callbackStr.includes('(') && callbackStr.includes(')')) {
           // 创建一个函数来执行表达式
           callback = new Function(callbackStr) as () => void
         } else {
           // 尝试3: 直接从 window 获取 (如 alert, console.log)
           callback = (window as any)[callbackStr]
         }
       }
      
      if (typeof callback !== 'function') {
        console.warn('auth-callback 解析失败:', callbackStr)
        callback = null
      }
    } catch (e) {
      console.error('auth-callback 解析错误:', e)
      callback = null
    }
  }
  
  console.log('1 callback', callback)
  console.log('1 authCode', authCode)
  
  const handler = memberAuthHandlers[authCode || ''] || default_auth
  
  console.log('2 handler', handler)
  
  if (handler) {
    const shouldContinue = handler.call(target as HTMLElement, event, target as HTMLElement, 'userid:123456', callback)
    console.log('3 shouldContinue', shouldContinue)
    
    if (!shouldContinue.state) {
      event.stopPropagation()
      event.preventDefault()
      ;(event as any)._handledByAuth = true
      if (shouldContinue.callback) {
        shouldContinue.callback()
      }
    }
  }
}, { capture: true });

(function() {
  const originalAddEventListener = EventTarget.prototype.addEventListener
  EventTarget.prototype.addEventListener = function(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions) {
    if (type === 'click') {
      const wrappedListener = function(this: EventTarget, event: Event) {
        if ((event as any)._handledByAuth) return
        return (listener as Function).apply(this, arguments)
      }
      return originalAddEventListener.call(this, type, wrappedListener, options)
    }
    return originalAddEventListener.call(this, type, listener, options)
  }
})()

const MemberAuthManager: IMemberAuthManager = {
  register(authCode: string, handler: AuthHandler): void {
    if (typeof handler === 'function') {
      memberAuthHandlers[authCode] = handler
    }
  },
  
  unregister(authCode: string): void {
    delete memberAuthHandlers[authCode]
  }
}

function observeAuthAttributes(): MutationObserver {
  const restoringElements = new Set<HTMLElement>()
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        const attributeName = mutation.attributeName
        if (attributeName !== 'member-auth' && attributeName !== 'auth-callback') {
          return
        }
        
        const target = mutation.target as HTMLElement
        
        if (restoringElements.has(target)) {
          return
        }
        
        const originalAuthCode = (target as any)._originalAuthCode
        const originalAuthCallback = (target as any)._originalAuthCallback
        const currentAuthCode = target.getAttribute('member-auth')
        const currentAuthCallback = target.getAttribute('auth-callback')
        
        let needsRestore = false
        
        if (currentAuthCode !== originalAuthCode) {
          target.setAttribute('member-auth', originalAuthCode || '')
          console.warn('检测到 member-auth 属性被篡改，已自动恢复', target)
          needsRestore = true
        }
        
        if (currentAuthCallback !== originalAuthCallback) {
          if (originalAuthCallback) {
            target.setAttribute('auth-callback', originalAuthCallback)
          } else {
            target.removeAttribute('auth-callback')
          }
          console.warn('检测到 auth-callback 属性被篡改，已自动恢复', target)
          needsRestore = true
        }
        
        if (needsRestore) {
          restoringElements.add(target)
          setTimeout(() => {
            restoringElements.delete(target)
          }, 0)
        }
      } else if (mutation.type === 'childList') {
        // 处理新增的子节点
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // 元素节点
            const element = node as HTMLElement
            // 检查当前元素是否有 member-auth 属性
            if (element.hasAttribute('member-auth')) {
              setupElement(element)
            }
            // 检查子元素中是否有 member-auth 属性
            const childElements = element.querySelectorAll('[member-auth]')
            childElements.forEach(setupElement)
          }
        })
      }
    })
  })
  
  function setupElement(el: Element) {
    const element = el as any
    if (!element._originalAuthCode) {
      element._originalAuthCode = element.getAttribute('member-auth')
      element._originalAuthCallback = element.getAttribute('auth-callback')
      observer.observe(el, { attributes: true, attributeFilter: ['member-auth', 'auth-callback'] })
    }
  }
  
  // 初始设置
  const targetElements = document.querySelectorAll('[member-auth]')
  targetElements.forEach(setupElement)
  
  // 观察整个文档的子节点变化，以捕获动态添加的元素
  observer.observe(document, { 
    childList: true, 
    subtree: true 
  })
  
  return observer
}

document.addEventListener('DOMContentLoaded', () => {
  observeAuthAttributes()
})

export { memberAuthHandlers, MemberAuthManager, observeAuthAttributes }
